import React from "react";
import { SearchOutlined, LoadingOutlined } from "@ant-design/icons";
import {
  Button,
  DatePicker,
  Input,
  message,
  Select,
  Space,
  Table,
} from "antd";
import "./Coach.css";
import moment from "moment";
import Highlighter from "react-highlight-words";
import { Link } from "react-router-dom";
import StepViewCard from "./StepViewCard";
import { step_names } from './StepNames';
const { TextArea } = Input;

const getEarliestDate = (arr) => {
  if (!arr || arr.length === 0) return '';
  return arr.reduce((earliest, current) =>
    current.date < earliest ? current.date : earliest
  , arr[0]?.date || '');
};

const getLatestDate = (arr) => {
  if (!arr || arr.length === 0) return '';
  return arr.reduce((latest, current) =>
    current.date < latest ? current.date : latest
  , arr[0]?.date || '');
};

export const COLUMNS = (getColumnSearchProps, OnFormChange) => [
  {
    title: "Client",
    width: "190px",
    dataIndex: "client",
    key: "client",
    fixed: "left",
    className: "col-class",
    sorter: {
      compare: (a, b) =>
        a.client
          ? a.client
              .toString()
              .localeCompare(b.client.toString())
          : true,
      //
    },
    sortDirections: ['ascend', 'descend', 'ascend'],
    defaultSortOrder: "ascend",
    ...getColumnSearchProps("client"),
  },
  // {
  //   title: "Last Communication",
  //   dataIndex: "last_comm_on",
  //   key: "1",
  //   width: "250px",
  //   hidden: true,
  //   // width: "200px",
  //   showSorterTooltip: false,
  //  sorter: {
  //  sorter: {
  //     compare: (a, b) =>
  //       a.last_comm_on
  //         ? a.last_comm_on
  //             .toString()
  //             .localeCompare(b.last_comm_on.toString())
  //         : true,
  //     //
  //   },
  //  sortDirections: ['ascend', 'descend', 'ascend'],
  //   render: (text, record) => (
  //     <>
  //       <div>
  //         <span style={{ fontSize: "14px" }} className="sms-span">
  //           <Select
  //             style={{ width: 70 }}
  //             bordered={false}
  //             defaultValue={record.last_comm === "TE" ? "SMS" : "Email"}
  //             onChange={(e) =>
  //               this.OnFormChange(
  //                 e,
  //                 "last_communication_mode",
  //                 record.client_id
  //               )
  //             }
  //           >
  //             <Option value="TE">SMS</Option>
  //             <Option value="EM">Email</Option>
  //           </Select>
  //           By &nbsp;&nbsp;
  //         </span>
  //         <Input
  //           className="lco-inp"
  //           defaultValue={
  //             record.last_comm_by ? record.last_comm_by : "Rachel"
  //           }
  //           onBlur={(e) =>
  //             this.OnFormChange(
  //               e,
  //               "last_communication_by",
  //               record.client_id
  //             )
  //           }
  //         ></Input>
  //         {/* <span style={{opacity:'50%',fontSize:'12px'}}>Anna Tim</span> */}
  //       </div>
  //       <div>
  //         <DatePicker
  //           style={{ padding: "0", width: "120px" }}
  //           defaultValue={
  //             record.last_comm_on._isValid ? record.last_comm_on : null
  //           }
  //           onChange={(date, datestring) =>
  //             this.OnFormChange(
  //               date,
  //               "last_communicated_on",
  //               record.client_id,
  //               datestring
  //             )
  //           }
  //           bordered={false}
  //         />
  //       </div>
  //     </>
  //   ),
  // },
  {
    title: "Start Date",
    dataIndex: "startdate",
    key: "3",
    width: "95px",
    showSorterTooltip: false,
    sorter: {
      compare: (a, b) =>
        {
          // return a.startdate ? a.startdate.localeCompare(b.startdate) : true
          let dateA = a.startdate ? new Date(a.startdate) : new Date(0); // Default to epoch if empty
          let dateB = b.startdate ? new Date(b.startdate) : new Date(0);
          // console.log("start_date", a.startdate, b.startdate, dateA, dateB)

          return dateA - dateB; // Numeric comparison for dates
        }
    },
    sortDirections: ['ascend', 'descend', 'ascend'],
  },
  {
    title: "Total Time spent",
    dataIndex: "time_spent",
    key: "4",
    width: "130px",
    showSorterTooltip: false,
    sorter: {
      compare: (a, b) =>
        a.time_spent_comp
          ? a.time_spent_comp < b.time_spent_comp
            ? 1
            : -1
          : true,
    },
    sortDirections: ['ascend', 'descend', 'ascend'],
  },
  {
    title: "Last Meeting",
    dataIndex: "last_call",
    key: "5",
    width: "150px",
    height: "100px",
    showSorterTooltip: false,
    sorter: {
      compare: (a, b) =>
        {
          // // Handle cases where last_call is invalid or missing
          // // Handle cases where last_call is invalid or missing
          if (!a.last_call || !a.last_call.isValid()) return 1;  // Move invalid/missing dates to the bottom
          if (!b.last_call || !b.last_call.isValid()) return -1;

          // Compare valid moment objects
          return a.last_call.isBefore(b.last_call) ? -1 : 1;
        }
    },
    sortDirections: ['ascend', 'descend', 'ascend'],
    render: (text, record) => (
      <>
        {/* {console.log('last_call',text,typeof text)} */}
        <DatePicker
          style={{ padding: "0" }}
          defaultValue={text._isValid ? text : null}
          className="lc-input"
          format="MMM DD, YYYY"
          onChange={(date, datestring) =>
            OnFormChange(
              date,
              "last_call",
              record.client_id,
              moment(datestring).format("YYYY-MM-DD")
            )
          }
          bordered={false}
        />
      </>
    ),
  },
  {
    title: "Coach Notes",
    dataIndex: "coachnotes",
    key: "6",
    width: "140px",
    className: "col-coach-notes white-background-cell",
    // width: "150px",
    showSorterTooltip: false,
    sorter: {
      // compare: (a, b) =>
      //   a.con_obj ? a.con_obj.status.localeCompare(b.con_obj.status) : false,
    },
    // sortDirections: ['ascend', 'descend', 'ascend'],
    render: (text, record) => (
      <TextArea
        className="coach-notes-textarea"
        rows={2}
        onChange={(val) =>
          OnFormChange(val, "coach_notes", record.client_id)
        }
        defaultValue={record.coach_notes}
      />
    ),
  },

  {
    title: "Status",
    dataIndex: "status",
    key: "7",
    width: "90px",
    showSorterTooltip: false,
    sorter: {
      compare: (a, b) =>
        a.status ? a.status.localeCompare(b.status) : false,
    },
    sortDirections: ['ascend', 'descend', 'ascend'],
    render: (text, record) => (
      <>
        <button
          className="status-btn"
          style={{
            background:
              record.status === "Active"
                ? "#D1FBBD"
                : record.status === "Light Active"
                ? "#FFFBD9"
                : "#FBBDBD",
            color:
              record.status === "Active"
                ? "#0A8A1D"
                : record.status === "Light Active"
                ? "#C8B700"
                : "#8a0a0a",
            cursor: "default",
          }}
          status={record.status}
        >
          {record.status}
        </button>
      </>
    ),
  },
  {
    title: "Last Activity",
    dataIndex: "last_activity_days",
    key: "2",
    width: "140px",
    showSorterTooltip: false,
    sorter: {
      compare: (a, b) =>
        a.last_activity
          ? a.last_activity.localeCompare(b.last_activity)
          : true,
    },
    sortDirections: ['ascend', 'descend', 'ascend'],
    render: (text, record) => (
      <>
      {/* {step_names[steps.indexOf(record.last_activity_step)] ? */}
      {step_names[record.last_activity_step] ?
        <>
          <h3 style={{ fontSize: "12px", marginBottom: "2px", }}>
            {record.last_activity_days} days ago
          </h3>
          <div style={{ color: "#888888", fontSize: "10px" }}>
            {/* {step_names[steps.indexOf(record.last_activity_step)]} */}
            {step_names[record.last_activity_step]}
          </div>
        </>
      :
       <>
        <h3 style={{ fontSize: "12px", marginBottom: "0" }}>
          {record.last_activity_days} days ago
        </h3>
       </>
      }
      </>
    ),
  },
  // {
  //   title: 'Onboarding', dataIndex: 'on_obj', key: '8',
  //   showSorterTooltip: false,
  //   sorter: {
  //     compare: (a, b) => (a.on_obj) ? a.on_obj.status.localeCompare(b.on_obj.status) : false,
  //
  //   },
  //   render:(text,record)=>(
  //      record.on_obj &&  <Selectbutton step_obj={record.on_obj} />
  //     )
  // },
  {
    title: "Last Step Completed",
    dataIndex: "lsc_obj",
    key: "30",
    width: "180px",
    className: "white-background-cell",
    showSorterTooltip: false,
    sorter: {
      compare: (a, b) =>
      {
        const aDate = a.lsc_obj ? getLatestDate(a.lsc_obj) : '';
        const bDate = b.lsc_obj ? getLatestDate(b.lsc_obj) : '';
        return aDate.localeCompare(bDate);
      },
    },
    sortDirections: ['ascend', 'descend', 'ascend'],
    render: (text, record) =>
      record.lsc_obj && (
        <>
          <StepViewCard step_obj={record.lsc_obj} status_cat="last-step-completed"/>
        </>
      ),
  },
  {
    title: "Ready For Review",
    dataIndex: "rfr_obj",
    key: "31",
    width: "570px",
    className: "white-background-cell",
    showSorterTooltip: false,
    sorter: {
      compare: (a, b) =>
        {
          const aDate = a.rfr_obj ? getLatestDate(a.rfr_obj) : '';
          const bDate = b.rfr_obj ? getLatestDate(b.rfr_obj) : '';
          return aDate.localeCompare(bDate);
        },
    },
    sortDirections: ['ascend', 'descend', 'ascend'],
    render: (text, record) =>
      record.rfr_obj && (
        <>
          <StepViewCard step_obj={record.rfr_obj} status_cat="for-review"/>
        </>
      ),
  },
  {
    title: "Client Requested Access To",
    dataIndex: "rac_obj",
    key: "32",
    width: "570px",
    className: "white-background-cell",
    showSorterTooltip: false,
    sorter: {
      compare: (a, b) =>
        {
          const aDate = a.rac_obj ? getLatestDate(a.rac_obj) : '';
          const bDate = b.rac_obj ? getLatestDate(b.rac_obj) : '';
          return aDate.localeCompare(bDate);
        },
    },
    sortDirections: ['ascend', 'descend', 'ascend'],
    render: (text, record) =>
      record.rac_obj && (
        <>
          <StepViewCard step_obj={record.rac_obj} status_cat="request-access"/>
        </>
      ),
  },
  {
    title: "Steps in Progress",
    dataIndex: "sip_obj",
    key: "33",
    width: "570px",
    className: "white-background-cell",
    showSorterTooltip: false,
    sorter: {
      compare: (a, b) =>
        {
          const aDate = a.sip_obj ? getLatestDate(a.sip_obj) : '';
          const bDate = b.sip_obj ? getLatestDate(b.sip_obj) : '';
          return aDate.localeCompare(bDate);
        },
    },
    sortDirections: ['ascend', 'descend', 'ascend'],
    render: (text, record) =>
      record.sip_obj && (
        <>
          <StepViewCard step_obj={record.sip_obj} status_cat="steps-in-progress"/>
        </>
      ),
  },
  // {
  //   title: "Assessment",
  //   dataIndex: "as_obj",
  //   key: "9",
  //   width: "150px",
  //   showSorterTooltip: false,
  //   sorter: {
  //     compare: (a, b) =>
  //       a.as_obj ? a.as_obj.status.localeCompare(b.as_obj.status) : false,
  //   },
  //   render: (text, record) =>
  //     record.as_obj && (
  //       <>
  //         <Selectbutton step_obj={record.as_obj} />
  //       </>
  //     ),
  // },
  // {
  //   title: "Target - Roles",
  //   dataIndex: "tr_obj",
  //   key: "10",
  //   width: "150px",
  //   showSorterTooltip: false,
  //   sorter: {
  //     compare: (a, b) =>
  //       a.tr_obj ? a.tr_obj.status.localeCompare(b.tr_obj.status) : false,
  //   },
  //   render: (text, record) =>
  //     record.tr_obj && <Selectbutton step_obj={record.tr_obj} />,
  // },
  // {
  //   title: "Target - Industries",
  //   dataIndex: "ti_obj",
  //   key: "11",
  //   width: "150px",
  //   showSorterTooltip: false,
  //   sorter: {
  //     compare: (a, b) =>
  //       a.ti_obj ? a.ti_obj.status.localeCompare(b.ti_obj.status) : false,
  //   },
  //   render: (text, record) =>
  //     record.ti_obj && <Selectbutton step_obj={record.ti_obj} />,
  // },
  // {
  //   title: "Research - Roles",
  //   dataIndex: "rr_obj",
  //   key: "12",
  //   width: "150px",
  //   showSorterTooltip: false,
  //   sorter: {
  //     compare: (a, b) =>
  //       a.rr_obj ? a.rr_obj.status.localeCompare(b.rr_obj.status) : false,
  //   },
  //   render: (text, record) =>
  //     record.rr_obj && <Selectbutton step_obj={record.rr_obj} />,
  // },
  // {
  //   title: "Research - Industries",
  //   dataIndex: "ri_obj",
  //   key: "13",
  //   width: "150px",
  //   showSorterTooltip: false,
  //   sorter: {
  //     compare: (a, b) =>
  //       a.ri_obj ? a.ri_obj.status.localeCompare(b.ri_obj.status) : false,
  //   },
  //   render: (text, record) =>
  //     record.ri_obj && <Selectbutton step_obj={record.ri_obj} />,
  // },
  // {
  //   title: "Contacts",
  //   dataIndex: "co_obj",
  //   key: "14",
  //   width: "150px",
  //   showSorterTooltip: false,
  //   sorter: {
  //     compare: (a, b) =>
  //       a.co_obj ? a.co_obj.status.localeCompare(b.co_obj.status) : false,
  //   },
  //   render: (text, record) =>
  //     record.co_obj && <Selectbutton step_obj={record.co_obj} />,
  // },
  // {
  //   title: "Email Drafts",
  //   dataIndex: "ed_obj",
  //   key: "15",
  //   width: "150px",
  //   showSorterTooltip: false,
  //   sorter: {
  //     compare: (a, b) =>
  //       a.ed_obj ? a.ed_obj.status.localeCompare(b.ed_obj.status) : false,
  //   },
  //   render: (text, record) =>
  //     record.ed_obj && <Selectbutton step_obj={record.ed_obj} />,
  // },
  // {
  //   title: "Setup Call with Coach",
  //   dataIndex: "midway",
  //   key: "16",
  //   width: "150px",
  //   showSorterTooltip: false,
  //   render: (text, record) =>
  //     record.mi_obj && (
  //       <Button
  //         className="midway-btn"
  //         onClick={() => this.setupCall(record.mi_obj, "setup-call")}
  //       >
  //         Setup A Call
  //       </Button>
  //     ),
  // },
  // {
  //   title: "Networking - Tracker",
  //   dataIndex: "nt_obj",
  //   key: "17",
  //   width: "150px",
  //   showSorterTooltip: false,
  //   sorter: {
  //     compare: (a, b) =>
  //       a.nt_obj ? a.nt_obj.status.localeCompare(b.nt_obj.status) : false,
  //   },
  //   render: (text, record) =>
  //     record.nt_obj && (
  //       <Selectbutton
  //         step_obj={record.nt_obj}
  //         cn_obj={record.cn_obj}
  //         cp_obj={record.cp_obj}
  //       />
  //     ),
  // },
  // {
  //   title: "Call Prep & Call Notes",
  //   dataIndex: "cp_obj",
  //   key: "18",
  //   width: "150px",
  //   showSorterTooltip: false,
  //   sorter: {
  //     compare: (a, b) =>
  //       a.cp_obj ? a.cp_obj.status.localeCompare(b.cp_obj.status) : false,
  //   },
  //   render: (text, record) =>
  //     record.cp_obj && (
  //       <Selectbutton step_obj={record.cp_obj} cn_obj={record.cn_obj} />
  //     ),
  // },
  // {
  //   title: "Networking Reflections",
  //   dataIndex: "nr_obj",
  //   key: "19",
  //   width: "150px",
  //   showSorterTooltip: false,
  //   sorter: {
  //     compare: (a, b) =>
  //       a.nr_obj ? a.nr_obj.status.localeCompare(b.nr_obj.status) : false,
  //   },
  //   render: (text, record) =>
  //     record.nr_obj && <Selectbutton step_obj={record.nr_obj} />,
  // },
  // {
  //   title: "Experiential Learning",
  //   dataIndex: "ex_obj",
  //   key: "20",
  //   width: "150px",
  //   showSorterTooltip: false,
  //   sorter: {
  //     compare: (a, b) =>
  //       a.ex_obj ? a.ex_obj.status.localeCompare(b.ex_obj.status) : false,
  //   },
  //   render: (text, record) =>
  //     record.ex_obj && <Selectbutton step_obj={record.ex_obj} />,
  // },
  // {
  //   title: "Next phase",
  //   dataIndex: "next-phase",
  //   key: "21",
  //   width: "150px",
  //   showSorterTooltip: false,
  //   render: (text, record) =>
  //     record.mi_obj && (
  //       <Button
  //         className="midway-btn"
  //         onClick={() => this.setupCall(record.np_obj, "nextphase")}
  //       >
  //         Release
  //       </Button>
  //     ),
  // },
  // {
  //   title: "Professional Summary",
  //   dataIndex: "ps_obj",
  //   key: "22",
  //   width: "150px",
  //   showSorterTooltip: false,
  //   sorter: {
  //     compare: (a, b) =>
  //       a.ps_obj ? a.ps_obj.status.localeCompare(b.ps_obj.status) : false,
  //   },
  //   render: (text, record) =>
  //     record.ps_obj && <Selectbutton step_obj={record.ps_obj} />,
  // },
  // {
  //   title: "Resume",
  //   dataIndex: "re_obj",
  //   key: "23",
  //   width: "150px",
  //   showSorterTooltip: false,
  //   sorter: {
  //     compare: (a, b) =>
  //       a.re_obj ? a.re_obj.status.localeCompare(b.re_obj.status) : false,
  //   },
  //   render: (text, record) =>
  //     record.re_obj && <Selectbutton step_obj={record.re_obj} />,
  // },
  // {
  //   title: "Cover letter",
  //   dataIndex: "cl_obj",
  //   key: "24",
  //   width: "150px",
  //   showSorterTooltip: false,
  //   sorter: {
  //     compare: (a, b) =>
  //       a.cl_obj ? a.cl_obj.status.localeCompare(b.cl_obj.status) : false,
  //   },
  //   render: (text, record) =>
  //     record.cl_obj && <Selectbutton step_obj={record.cl_obj} />,
  // },
  // {
  //   title: "LinkedIn",
  //   dataIndex: "li_obj",
  //   key: "25",
  //   width: "150px",
  //   showSorterTooltip: false,
  //   sorter: {
  //     compare: (a, b) =>
  //       a.li_obj ? a.li_obj.status.localeCompare(b.li_obj.status) : false,
  //   },
  //   render: (text, record) =>
  //     record.li_obj && <Selectbutton step_obj={record.li_obj} />,
  // },
  // {
  //   title: "Application - Tracker",
  //   dataIndex: "at_obj",
  //   key: "26",
  //   width: "150px",
  //   showSorterTooltip: false,
  //   sorter: {
  //     compare: (a, b) =>
  //       a.at_obj ? a.at_obj.status.localeCompare(b.at_obj.status) : false,
  //   },
  //   render: (text, record) =>
  //     record.at_obj && (
  //       <Selectbutton step_obj={record.at_obj} ir_obj={record.ir_obj} />
  //     ),
  // },
  // {
  //   title: "Interview - Research",
  //   dataIndex: "ir_obj",
  //   key: "27",
  //   width: "150px",
  //   showSorterTooltip: false,
  //   sorter: {
  //     compare: (a, b) =>
  //       a.ir_obj ? a.ir_obj.status.localeCompare(b.ir_obj.status) : false,
  //   },
  //   render: (text, record) =>
  //     record.ir_obj && <Selectbutton step_obj={record.ir_obj} />,
  // },
  // {
  //   title: "Behavioral - Int. Prep",
  //   dataIndex: "bp_obj",
  //   key: "28",
  //   width: "150px",
  //   showSorterTooltip: false,
  //   sorter: {
  //     compare: (a, b) =>
  //       a.bp_obj ? a.bp_obj.status.localeCompare(b.bp_obj.status) : false,
  //   },
  //   render: (text, record) =>
  //     record.bp_obj && <Selectbutton step_obj={record.bp_obj} />,
  // },
  // {
  //   title: "Job Search Reflections",
  //   dataIndex: "jr_obj",
  //   key: "29",
  //   width: "150px",
  //   showSorterTooltip: false,
  //   sorter: {
  //     compare: (a, b) =>
  //       a.jr_obj ? a.jr_obj.status.localeCompare(b.jr_obj.status) : false,
  //   },
  //   render: (text, record) =>
  //     record.jr_obj && <Selectbutton step_obj={record.jr_obj} />,
  // },
];